import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from '../../redux/hooks';
import { DateTime } from 'luxon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-width: 520px;
  margin: 0px auto;
  padding: 0px 24px;
`;

const CountdownContainer = styled.div`
  align-items: center;
  background-image: url(/assets/429-background-gradient.svg);
  display: flex;
  flex-direction: column;
  height: 220px;
  justify-content: center;
  position: relative;
  margin: 0px auto;
  width: 220px;
`;

const SecondsRemainingText = styled.h3`
  color: ${(props) => props.theme.colors.White};
  font-family: ${(props) => props.theme.fonts.grotesk};
  font-size: 48px;
  font-weight: 500;
  left: 50%;
  letter-spacing: -0.96px;
  line-height: 60px;
  position: absolute;
  text-align: center;
  top: 38%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

const SecondsLabel = styled.p`
  color: #F8F5FE;
  font-family: ${(props) => props.theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  left: 50%;
  line-height: 150%;
  position: absolute;
  top: 52%;
  transform: translate(-50%, -50%);
  z-index: 1;
  text-align: center;
`;

const Text = styled.p`
  color: ${(props) => props.theme.colors.Gray700};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;

const Header = styled.h6`
  color: ${(props) => props.theme.colors.Gray900};
  font-family: ${(props) => props.theme.fonts.inter};
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 8px;
  text-align: center;
`;

const FourTwoNineErrorPage = () => {
  const timeout429Timestamp = useSelector((state) => state.auth.timeout429Timestamp) || 0;
  const now = DateTime.now();
  const timeout429DateTime = DateTime.fromMillis(timeout429Timestamp);
  const secondsRemaining = timeout429DateTime.diff(now).as('seconds');
  const [secondsRemainingState, setSecondsRemainingState] = useState(secondsRemaining);

  useEffect(() => {
    let countdownTimeout: NodeJS.Timeout;
    let reloadTimeout: NodeJS.Timeout;

    if (secondsRemaining > 0) {
      countdownTimeout = setTimeout(() => {
        setSecondsRemainingState(secondsRemaining - 1);
      }, 1000);
    } else {
      reloadTimeout = setTimeout(() => window.location.reload(), 5000);
    }

    return () => {
      clearTimeout(countdownTimeout);
      clearTimeout(reloadTimeout);
    };
  }, [secondsRemaining, timeout429Timestamp]);

  return (
    <Container>
      <CountdownContainer>
        <SecondsRemainingText>{Math.max(0, secondsRemainingState).toFixed(0)}</SecondsRemainingText>
        <SecondsLabel>seconds</SecondsLabel>
      </CountdownContainer>

      <Header>High request volume</Header>
      <Text>
        We&apos;ve detected high request volume from your device.
      </Text>

      <Text>
        Please wait for the countdown to finish and refresh the page.
      </Text>
    </Container>
  );
};

export default FourTwoNineErrorPage;